import {
  Button,
  Dialog,
  DialogBackdrop,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogHeaderMain,
  DialogIcon,
  DialogTitle,
  Text,
} from '@zrsystem/ui';

export interface AppointmentConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmVariant?: 'primary' | 'danger';
  isPending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function AppointmentConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  confirmVariant = 'primary',
  isPending = false,
  onConfirm,
  onCancel,
}: AppointmentConfirmDialogProps) {
  if (!open) {
    return null;
  }

  return (
    <DialogBackdrop
      onClick={() => {
        if (!isPending) {
          onCancel();
        }
      }}
    >
      <Dialog
        aria-labelledby="appointment-confirm-title"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <DialogHeader>
          <DialogHeaderMain>
            <DialogIcon variant="warning">!</DialogIcon>
            <DialogTitle id="appointment-confirm-title">{title}</DialogTitle>
          </DialogHeaderMain>
        </DialogHeader>
        <DialogBody>
          <Text>{message}</Text>
        </DialogBody>
        <DialogFooter>
          <Button type="button" variant="ghost" disabled={isPending} onClick={onCancel}>
            Voltar
          </Button>
          <Button type="button" variant={confirmVariant} disabled={isPending} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </Dialog>
    </DialogBackdrop>
  );
}
